import Button from '@/presentation/components/elements/Button';
import SetRangeForm, {
  SetRangeFormFields,
} from '@/presentation/components/forms/CreatePositionForms/SetRangeForm';
import { Dispatch, useMemo, useState } from 'react';
import { useForm, useWatch } from 'react-hook-form';
import { Address } from 'nftx.js';
import { formatEther } from 'viem';
import { IncreaseLiquidityDetails } from '../types';

export interface SetRangeProps {
  symbol: string;
  vaultId?: string;
  icon?: string;
  dispatch: Dispatch<Partial<IncreaseLiquidityDetails>>;
  onSubmit: (...args: any) => void;
  liquidity: bigint;
  poolAddress: Address;
  tokenAddress: Address;
  state: IncreaseLiquidityDetails;
  ethMax: bigint;
  currentNFTPriceInETH: bigint;
  currentTick: bigint;
  currentApy: bigint;
  amountMax: bigint;
  using: 'nft' | 'vtoken';
  feeTier: string;
  poolType: 'nft' | 'pair' | 'eth';
  collectionAddress: Address;
}

export const SetRange = ({
  symbol,
  vaultId,
  icon,
  dispatch,
  onSubmit,
  liquidity,
  poolAddress,
  tokenAddress,
  state,
  ethMax,
  currentNFTPriceInETH,
  currentTick,
  currentApy,
  amountMax,
  using,
  feeTier,
  poolType,
  collectionAddress,
}: SetRangeProps) => {
  const {
    control,
    register,
    formState: { errors },
    setValue,
    handleSubmit,
  } = useForm<SetRangeFormFields>({
    defaultValues: {
      ethAmount: state.ethAmount,
      maxPriceInEth: state.maxPriceInEth,
      minPriceInEth: state.minPriceInEth,
      tickLower: state.tickLower,
      tickUpper: state.tickUpper,
      tokenAmount: state.tokenAmount,
      price: formatEther(currentNFTPriceInETH),
    },
  });

  const values = useWatch({ control });

  const onRangeFormSubmit = handleSubmit(async (values) => {
    dispatch({ ...values });
    onSubmit();
  });

  const [formDisabled, setFormDisabled] = useState(false);
  const disabled = useMemo(() => {
    if (formDisabled) {
      return true;
    }
    if (values.tokenAmount === '0' && values.ethAmount === '0') {
      return true;
    }
    return false;
  }, [formDisabled, values.ethAmount, values.tokenAmount]);

  return (
    <form onSubmit={onRangeFormSubmit} noValidate>
      <SetRangeForm
        feeTier={feeTier}
        control={control}
        errors={errors}
        isNewVault={false}
        isNewPool={false}
        liquidity={liquidity}
        poolAddress={poolAddress}
        poolType={poolType}
        setValue={setValue}
        symbol={symbol}
        tokenAddress={tokenAddress}
        icon={icon}
        vaultId={vaultId}
        amountMax={amountMax}
        ethMax={ethMax}
        currentTick={`${currentTick}`}
        apy={currentApy}
        using={using}
        canEditRange={false}
        setDisabled={setFormDisabled}
        register={register}
        collectionAddress={collectionAddress}
      />
      <Button
        size="xl"
        type="submit"
        className="w-full mt-6"
        disabled={disabled}
      >
        {'Increase liquidity'}
      </Button>
    </form>
  );
};

export default SetRange;
